export default{
  router: {
    home: 'Home',
    shop: 'Shop',
    pay: 'Pay',
    user: 'User',
    userList: 'User List',
    menuShop: 'Shop',
    shopList: 'Shop List',
    addShop: 'Add Shop',
    updateShop: 'Update Shop',
    product: 'Product',
    productList: 'Product List',
    addProduct: 'Add Product',
    updateProduct: 'Update Product',
    productCate: 'Product Category',
    addProductCate: 'Add Product Category',
    updateProductCate: 'Update Product Category',
    productAttr: 'Product Type',
    productAttrList: 'Product Attribute List',
    addProductAttr: 'Add Product Attribute',
    updateProductAttr: 'Update Product Attribute',
    brand: 'Brand Management',
    addBrand: 'Add Brand',
    updateBrand: 'Edit Brand',
    order: 'Order',
    orderList: 'Order List',
    orderDetail: 'Order Detail',
    deliverOrderList: 'Deliver Order List',
    orderSetting: 'Order Setting',
    returnApply: 'Return Apply',
    returnReason: 'Return Reason',
    returnApplyDetail: 'Return Apply Detail',
    marketing: 'Marketing',
    flashSale: 'Flash Sale List',
    flashSession: 'Flash Session List',
    selectSession: 'Select Session',
    flashProductRelation: 'Flash Product Relation',
    couponList: 'Coupon List',
    addCoupon: 'Add Coupon',
    updateCoupon: 'Update Coupon',
    couponHistory: 'Coupon History',
    brandRecommendation: 'Brand Recommendation',
    newProduct: 'New Product',
    popularProduct: 'Popular Product',
    specialTopic: 'Special Topic',
    advertiseList: 'Advertise List',
    addAdvertise: 'Add Advertise',
    editAdvertise: 'Edit Advertise',
    permission: 'Permission',
    roleList: 'Role List',
    allocMenu: 'Allocate Menu',
    allocResource: 'Allocate Resource',
    menuList: 'Menu List',
    addMenu: 'Add Menu',
    updateMenu: 'Update Menu',
    resourceList: 'Resource List',
    resourceCategory: 'Resource Category'
  },


  "uploadButtonText": "Click to Upload",
  "uploadTip": "Only jpg/png files can be uploaded, and no more than 10MB",
  "exceedLimitMessage": "You can upload up to {maxCount} images",
  "login": "Login",
  "register":"Register",

  "menuShop":"Store",
  "menuShopList":"Store List",
  "menuShopAdd":"Store Add",
  "menuCommodity":"Commodity",
  "menuCommodityList":"Commodity List",
  "menuCommodityAdd":"Commodity Add",
  "menuCommodityCategory":"Commodity Category",
  "menuCommodityCKind":"Commodity Kind",
  "app.name": "Hello uni-app",
  "user.title": "Mine",
  "cart.title": "Cart",
  "kind.title": "Kind",
  "shop.title": "Shop",
  "switch.title": "Switch",
  "applySuccess": "Apply Success",
  "noFound": "Please validate your code",
  "repeatRequest": "Have Repeated submit application",
  "success": "Success",

  shop: {
    paypalClientId:"Paypal ClientId",
    paypalSecretKey:"Secret Key",
    barcodeTitle:"Invite Link Barcode",
    appPaste:"Share App Invite Url",
    appBarcode:"Share App Invite Barcode",
    barcode:"Share Invite Barcode",
    autoApprove:'Customer Auto Approve',
    paypalAccount:"Paypal Account",
    blockchainAddress:"Wallet Address",
    select:"Select",
    paypal:"Offline Paypal",
    onlinePaypal:"Online Paypal",
    blockchainNetwork:"Blockchain Network",
    blockchain:"Offline Blockchain",
    paymentMethod:"Payment Method",
    addPayment:"Add payment method",
    success:"Success",
    failed:"Failed",
    searchFilter: 'Search Filter',
    searchResults: 'Search',
    inputSearch: 'Input Search:',
    keywordPlaceholder: 'Keyword',
    dataList: 'Data List',
    addButton: 'Add',
    id: 'ID',
    paste: 'Share Invite Url',
    shopName: 'Shop Name',
    legalPersonName: 'Legal Person Name',
    country: 'Country',
    city: 'City',
    companyName: 'Company Name',
    editButton: 'Edit',
    deleteButton: 'Delete',
    deleteConfirmation: 'Are you sure you want to delete this brand',
    prompt: 'Prompt',
    confirm: 'Confirm',
    cancel: 'Cancel',
    deleteSuccess: 'Delete Success',
    showBrand: 'Show Brand',
    hideBrand: 'Hide Brand',
    name: 'Name',
    auto:'Auto',
    manual:'Manual',
    streetLine1: 'Address Line 1',
    addressLine2: 'Address Line 2',
    firstName: 'First Name',
    inviteCode: 'Invite Code',
    lastName: 'Last Name',
    phone: 'Phone(Whatsapp)',
    status: 'Status',
    postcode: 'Postcode',
    currency: 'Currency',
    icon: 'Icon',
    submit: 'Submit',
    reset: 'Reset',
    enterName: 'Please enter name',
    nameLength: 'Length must be between 2 and 140 characters',
    confirmSubmit: 'Do you want to submit the data',
    editSuccess: 'Edit Successful',
    submitSuccess: 'Submission Successful',
    validationFailed: 'Validation Failed',
    selectCountry:'Select Country',
    "Afghanistan": "Afghanistan",
    "Albania": "Albania",
    "Algeria": "Algeria",
    "Andorra": "Andorra",
    "Angola": "Angola",
    "Antigua and Barbuda": "Antigua and Barbuda",
    "Argentina": "Argentina",
    "Armenia": "Armenia",
    "Australia": "Australia",
    "Austria": "Austria",
    "Azerbaijan": "Azerbaijan",
    "Bahamas": "Bahamas",
    "Bahrain": "Bahrain",
    "Bangladesh": "Bangladesh",
    "Barbados": "Barbados",
    "Belarus": "Belarus",
    "Belgium": "Belgium",
    "Belize": "Belize",
    "Benin": "Benin",
    "Bhutan": "Bhutan",
    "Bolivia": "Bolivia",
    "Bosnia and Herzegovina": "Bosnia and Herzegovina",
    "Botswana": "Botswana",
    "Brazil": "Brazil",
    "Brunei": "Brunei",
    "Bulgaria": "Bulgaria",
    "Burkina Faso": "Burkina Faso",
    "Burundi": "Burundi",
    "Cambodia": "Cambodia",
    "Cameroon": "Cameroon",
    "Canada": "Canada",
    "Cape Verde": "Cape Verde",
    "Central African Republic": "Central African Republic",
    "Chad": "Chad",
    "Chile": "Chile",
    "China": "China",
    "Colombia": "Colombia",
    "Comoros": "Comoros",
    "Congo Republic": "Congo Republic",
    "Congo Democratic Republic": "Congo Democratic Republic",
    "Costa Rica": "Costa Rica",
    "Ivory Coast": "Ivory Coast",
    "Croatia": "Croatia",
    "Cuba": "Cuba",
    "Cyprus": "Cyprus",
    "Czech Republic": "Czech Republic",
    "Denmark": "Denmark",
    "Djibouti": "Djibouti",
    "Dominica": "Dominica",
    "Dominican Republic": "Dominican Republic",
    "East Timor": "East Timor",
    "Ecuador": "Ecuador",
    "Egypt": "Egypt",
    "El Salvador": "El Salvador",
    "Equatorial Guinea": "Equatorial Guinea",
    "Eritrea": "Eritrea",
    "Estonia": "Estonia",
    "Eswatini": "Eswatini",
    "Ethiopia": "Ethiopia",
    "Fiji": "Fiji",
    "Finland": "Finland",
    "France": "France",
    "Gabon": "Gabon",
    "Gambia": "Gambia",
    "Georgia": "Georgia",
    "Germany": "Germany",
    "Ghana": "Ghana",
    "Greece": "Greece",
    "Grenada": "Grenada",
    "Guatemala": "Guatemala",
    "Guinea": "Guinea",
    "Guinea-Bissau": "Guinea-Bissau",
    "Guyana": "Guyana",
    "Haiti": "Haiti",
    "Honduras": "Honduras",
    "Hungary": "Hungary",
    "Iceland": "Iceland",
    "India": "India",
    "Indonesia": "Indonesia",
    "Iran": "Iran",
    "Iraq": "Iraq",
    "Ireland": "Ireland",
    "Israel": "Israel",
    "Italy": "Italy",
    "Jamaica": "Jamaica",
    "Japan": "Japan",
    "Jordan": "Jordan",
    "Kazakhstan": "Kazakhstan",
    "Kenya": "Kenya",
    "Kiribati": "Kiribati",
    "South Korea": "South Korea",
    "Kuwait": "Kuwait",
    "Kyrgyzstan": "Kyrgyzstan",
    "Laos": "Laos",
    "Latvia": "Latvia",
    "Lebanon": "Lebanon",
    "Lesotho": "Lesotho",
    "Liberia": "Liberia",
    "Libya": "Libya",
    "Liechtenstein": "Liechtenstein",
    "Lithuania": "Lithuania",
    "Luxembourg": "Luxembourg",
    "Madagascar": "Madagascar",
    "Malawi": "Malawi",
    "Malaysia": "Malaysia",
    "Maldives": "Maldives",
    "Mali": "Mali",
    "Malta": "Malta",
    "Marshall Islands": "Marshall Islands",
    "Mauritania": "Mauritania",
    "Mauritius": "Mauritius",
    "Mexico": "Mexico",
    "Micronesia": "Micronesia",
    "Moldova": "Moldova",
    "Monaco": "Monaco",
    "Mongolia": "Mongolia",
    "Montenegro": "Montenegro",
    "Morocco": "Morocco",
    "Mozambique": "Mozambique",
    "Myanmar": "Myanmar",
    "Namibia": "Namibia",
    "Nauru": "Nauru",
    "Nepal": "Nepal",
    "Netherlands": "Netherlands",
    "New Zealand": "New Zealand",
    "Nicaragua": "Nicaragua",
    "Niger": "Niger",
    "Nigeria": "Nigeria",
    "North Macedonia": "North Macedonia",
    "Norway": "Norway",
    "Oman": "Oman",
    "Pakistan": "Pakistan",
    "Palau": "Palau",
    "Palestine": "Palestine",
    "Panama": "Panama",
    "Papua New Guinea": "Papua New Guinea",
    "Paraguay": "Paraguay",
    "Peru": "Peru",
    "Philippines": "Philippines",
    "Poland": "Poland",
    "Portugal": "Portugal",
    "Qatar": "Qatar",
    "Romania": "Romania",
    "Russia": "Russia",
    "Rwanda": "Rwanda",
    "Saint Kitts and Nevis": "Saint Kitts and Nevis",
    "Saint Lucia": "Saint Lucia",
    "Saint Vincent and the Grenadines": "Saint Vincent and the Grenadines",
    "Samoa": "Samoa",
    "San Marino": "San Marino",
    "Sao Tome and Principe": "Sao Tome and Principe",
    "Saudi Arabia": "Saudi Arabia",
    "Senegal": "Senegal",
    "Serbia": "Serbia",
    "Seychelles": "Seychelles",
    "Sierra Leone": "Sierra Leone",
    "Singapore": "Singapore",
    "Slovakia": "Slovakia",
    "Slovenia": "Slovenia",
    "Solomon Islands": "Solomon Islands",
    "Somalia": "Somalia",
    "South Africa": "South Africa",
    "South Sudan": "South Sudan",
    "Spain": "Spain",
    "Sri Lanka": "Sri Lanka",
    "Sudan": "Sudan",
    "Suriname": "Suriname",
    "Sweden": "Sweden",
    "Switzerland": "Switzerland",
    "Syria": "Syria",
    "Tajikistan": "Tajikistan",
    "Tanzania": "Tanzania",
    "Thailand": "Thailand",
    "East Timor": "East Timor",
    "Togo": "Togo",
    "Tonga": "Tonga",
    "Trinidad and Tobago": "Trinidad and Tobago",
    "Tunisia": "Tunisia",
    "Turkey": "Turkey",
    "Turkmenistan": "Turkmenistan",
    "Tuvalu": "Tuvalu",
    "Uganda": "Uganda",
    "Ukraine": "Ukraine",
    "United Arab Emirates": "United Arab Emirates",
    "United Kingdom": "United Kingdom",
    "United States": "United States",
    "Uruguay": "Uruguay",
    "Uzbekistan": "Uzbekistan",
    "Vanuatu": "Vanuatu",
    "Vatican": "Vatican",
    "Venezuela": "Venezuela",
    "Vietnam": "Vietnam",
    "Yemen": "Yemen",
    "Zambia": "Zambia",
    "Zimbabwe": "Zimbabwe"
  },
  balance: {
    selectPaymentMethod: "Select payment method",
    exceedBalance: "Exceed balance limit",
    chooseOrder: "Choose order",
    username: "Username",
    realName: "Real Name",
    mobile: "Mobile Number",
    amount: "Amount",
    note: "Note",
    manualOrder: "Bind order manually",
    payType: "Pay Channel",
    createTime:"Create time",
    addOrderBtn:"Add Order",
    operations:"Operations",
    cashierAmount:"Cashier amount",
    orderNote: "Order Note",
    relatedOrder: "Related Order",
    totalAmount: "Total Order Amount",
    relatedOrders: "Related Orders",
    orderTotalAmount: "Order Total Amount",
    collectionTime: "Collection Time",
  },
  product: {
    filterSearch: 'Filter Search',
    queryResults: 'Query Results',
    reset: 'Reset',
    inputSearch: 'Input Search:',
    productSn: 'Product SN:',
    productCategory: 'Product Category:',
    publishStatus: 'Publish Status:',
    verifyStatus: 'Verify Status:',
    dataList: 'Data List',
    add: 'Add',
    number: 'Number',
    productImage: 'Product Image',
    productName: 'Product Name',
    priceSn: 'Price/SN',
    tags: 'Tags',
    shelf: 'Shelf:',
    new: 'New:',
    recommend: 'Recommend:',
    sort: 'Sort',
    skuStock: 'SKU Stock',
    sale: 'Sale',
    operation: 'Operation',
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    batchOperation: 'Batch Operation',
    confirm: 'Confirm',
    cancel: 'Cancel',
    editProductInfo: 'Edit Product Info',
    productSnText: 'Product SN:',
    searchBySku: 'Search by SKU',
    skuCode: 'SKU Code',
    salePrice: 'Sale Price',
    productStock: 'Product Stock',
    lowStock: 'Low Stock',
    successMessage: 'Successfully Modified',
    warningMessage: 'No SKU Information',
    searchPlaceholder: 'Product Name',
    selectPlaceholder: 'Please Select',
    all: 'All',
    filterOptions: {
      publishOn: 'Publish On',
      publishOff: 'Publish Off',
      recommendOn: 'Recommend On',
      recommendOff: 'Recommend Off',
      newOn: 'New On',
      newOff: 'New Off',
      transferCategory: 'Transfer to Category',
      recycle: 'Recycle'
    },
    statusOptions: {
      publishOn: 'On Shelf',
      publishOff: 'Off Shelf',
      verifyPassed: 'Verified',
      verifyNotPassed: 'Not Verified'
    }
  },
  productIndex: {
    filterSearch: "Filter Search",
    searchResult: "Search",
    reset: "Reset",
    inputSearch: "Input Search:",
    productName: "Product Name",
    productSn: "Product SN:",
    productCategory: "Product Category:",
    publishStatus: "Publish Status:",
    verifyStatus: "Verify Status:",
    all: "All",
    dataList: "Data List",
    add: "Add",
    number: "Number",
    productImage: "Product Image",
    brand: "Brand",
    priceSn: "Price/SN",
    price: "Price",
    label: "Label",
    publish: "Publish",
    new: "New",
    recommend: "Recommend",
    sort: "Sort",
    skuStock: "SKU Stock",
    sales: "Sales",
    operate: "Operate",
    view: "View",
    edit: "Edit",
    delete: "Delete",
    batchOperate: "Batch Operate",
    confirm: "Confirm",
    editSkuInfo: "Edit SKU Info",
    searchBySku: "Search by SKU",
    skuCode: "SKU Code",
    salePrice: "Sale Price",
    productStock: "Product Stock",
    lowStock: "Low Stock",
    cancel: "Cancel",
    noSkuInfo: "No SKU information available",
    confirmEdit: "Do you want to make changes?",
    prompt: "Prompt",
    editSuccess: "Successfully modified",
    selectOperateType: "Please select an operation type",
    selectProducts: "Please select the products to operate",
    confirmBatchOperate: "Do you want to proceed with this batch operation?",
    confirmDelete: "Do you want to proceed with the delete operation?",
    updateSuccess: "Successfully updated",
    deleteSuccess: "Successfully deleted",
    publishOn: "Publish On",
    publishOff: "Publish Off",
    recommendOn: "Recommend On",
    recommendOff: "Recommend Off",
    newOn: "New On",
    newOff: "New Off",
    transferCategory: "Transfer to Category",
    recycle: "Move to Recycle Bin",
    verifyPass: "Verified",
    unverified: "Unverified",
  },
  productAttr: {
    skuMode:"Sku Mode:",
    attrType: "Attribute Type:",
    selectAttrType: "Please select attribute type",
    productSpec: "Product Specification:",
    salePrice: "Sale Price",
    promotionPrice: "Promotion Price",
    stock: "Stock",
    lowStock: "Low Stock",
    skuCode: "SKU Code",
    operate: "Operate",
    delete: "Delete",
    add: "Add",
    refreshList: "Refresh List",
    syncPrice: "Same Price",
    syncStock: "Same Stock",
    attrImage: "Attribute Image:",
    productParam: "Product Parameter:",
    productAlbum: "Product Album:",
    productDetail: "Product Detail:",
    pcDetail: "PC Detail",
    mobileDetail: "Mobile Detail",
    prevStep: "Previous Step",
    finishCommit: "Finish, Submit Product",
    attrValueNotNull: "Attribute value cannot be empty",
    attrValueNotRepeat: "Attribute value cannot be repeated",
    confirmRefreshList: "Refreshing the list will regenerate SKU information. Do you want to refresh?",
    confirmSyncPrice: "Sync the price of the first SKU to all SKUs. Continue?",
    confirmSyncStock: "Sync the stock of the first SKU to all SKUs. Continue?",
    prompt: "Prompt",
    confirm: "Confirm",
    cancel: "Cancel"
  },
  productDetail: {
    fillProductInfo: "Fill Product Information",
    fillProductPromotion: "Fill Product Promotion",
    fillProductAttr: "Fill Product Attributes",
    confirmSubmit: "Do you want to submit this product?",
    prompt: "Prompt",
    confirm: "Confirm",
    cancel: "Cancel",
    submitSuccess: "Submitted successfully"
  },
  productInfoDetail: {
    productCategory: "Product Category:",
    productName: "Product Name:",
    subTitle: "Tag:",
    productDescription: "Product Description:",
    productSn: "Product SN:",
    productPrice: "Product Price:",
    originalPrice: "Original Price:",
    productStock: "Product Stock:",
    unit: "Unit:",
    productWeight: "Product Weight:",
    gram: "Gram",
    sort: "Sort",
    nextStep: "Next Step",
    enterProductName: "Please enter product name",
    nameLength: "Length should be between 2 and 140 characters",
    enterSubTitle: "Please enter sub title",
    selectProductCategory: "Please select product category",
    enterProductDescription: "Please enter product description",
    requiredField: "This field is required",
    enterContent: "Please enter content",
    validationFailed: "Validation Failed"
  },
  productSaleDetail: {
    productPublish: "Product Publish:",
    productRecommend: "Product Recommend:",
    newProduct: "New",
    recommend: "Recommend",
    serviceGuarantee: "Service Guarantee:",
    return: "Return",
    quickRefund: "Quick Refund",
    freeShipping: "Free Shipping",
    detailTitle: "Detail Page Title:",
    detailDesc: "Detail Page Description:",
    keywords: "Keywords:",
    note: "Note:",
    startTime: "Start Time",
    selectStartTime: "Select Start Time",
    endTime: "End Time",
    selectEndTime: "Select End Time",
    promotionPrice: "Promotion Price",
    enterPromotionPrice: "Enter Promotion Price",
    promotionType:"Price Strategy:",
    noPromotion: "Same Price",
    memberPrice: "Member Price",
    quantity: "Quantity",
    discount: "Discount",
    operate: "Operate",
    delete: "Delete",
    add: "Add",
    full: "Full",
    reduce: "Reduce",
    prevStep: "Previous Step",
    nextStep: "Next Step",
    maxThreeItems: "You can add up to three items"
  },
  productAttrIndex: {
    dataList: "Data List",
    add: "Add",
    id: "ID",
    typeName: "Type Name",
    attrCount: "Attribute Count",
    paramCount: "Parameter Count",
    settings: "Settings",
    attrList: "Attribute List",
    paramList: "Parameter List",
    operations: "Operations",
    edit: "Edit",
    delete: "Delete",
    cancel: "Cancel",
    confirm: "Confirm",
    addType: "Add Type",
    editType: "Edit Type",
    enterTypeName: "Please enter type name",
    confirmDelete: "Are you sure you want to delete this brand?",
    prompt: "Prompt",
    deleteSuccess: "Deleted successfully",
    addSuccess: "Added successfully",
    editSuccess: "Edited successfully"
  },
  productAttrList: {
    dataList: "Data List",
    add: "Add",
    id: "ID",
    attrName: "Attribute Name",
    productType: "Product Type",
    selectable: "Selectable",
    inputMethod: "Input Method",
    inputList: "Input List",
    sort: "Sort",
    actions: "Actions",
    edit: "Edit",
    delete: "Delete",
    batchOperation: "Batch Operation",
    confirm: "Confirm",
    selectRecord: "Please select a record",
    selectBatchType: "Please select a batch operation type",
    confirmDelete: "Are you sure you want to delete this attribute?",
    prompt: "Prompt",
    deleteSuccess: "Deleted successfully",
    inputFromList: "Select from list",
    manualInput: "Manual input",
    singleSelect: "Single select",
    multiSelect: "Multi select",
    unique: "Unique"
  },
  productAttrDetail: {
    stockDesp: "-1 indicates infinite stocks",
    attrName: "Attribute Name:",
    productType: "Product Type:",
    selectPlaceholder: "Please select",
    filterStyle: "Filter Style:",
    normal: "Normal",
    color: "Color",
    searchable: "Searchable:",
    noSearch: "No Search",
    keywordSearch: "Keyword Search",
    rangeSearch: "Range Search",
    related: "Related:",
    yes: "Yes",
    no: "No",
    selectable: "Selectable:",
    unique: "Unique",
    singleSelect: "Single Select",
    multiSelect: "Multi Select",
    inputMethod: "Input Method:",
    manualInput: "Manual Input",
    selectFromList: "Select from List",
    inputList: "Input List:",
    supportManualAdd: "Support Manual Add:",
    sort: "Sort:",
    submit: "Submit",
    reset: "Reset",
    enterAttrName: "Please enter attribute name",
    nameLength: "Length should be between 2 to 140 characters",
    confirmSubmit: "Do you want to submit the data?",
    prompt: "Prompt",
    confirm: "Confirm",
    cancel: "Cancel",
    submitSuccess: "Submitted successfully",
    editSuccess: "Edited successfully",
    validationFailed: "Validation failed"
  },
  productCate: {
    dataList: "Data List",
    add: "Add",
    id: "ID",
    name: "Name",
    level: "Level",
    productCount: "Product Count",
    productUnit: "Product Unit",
    navStatus: "Nav Status",
    showStatus: "Show Status",
    sort: "Sort",
    settings: "Settings",
    transferProduct: "Transfer Product",
    actions: "Actions",
    edit: "Edit",
    delete: "Delete",
    confirmDelete: "Are you sure you want to delete this category?",
    prompt: "Prompt",
    confirm: "Confirm",
    cancel: "Cancel",
    deleteSuccess: "Deleted successfully",
    editSuccess: "Edited successfully",
    level1: "Level 1",
    level2: "Level 2"
  },
  productCateDetail: {
    name: "Category Name:",
    productUnit: "Quantity Unit:",
    sort: "Sort:",
    showStatus: "Show Status:",
    yes: "Yes",
    no: "No",
    navStatus: "Show in Navigation:",
    icon: "Category Icon:",
    delete: "Delete",
    add: "Add",
    keywords: "Keywords:",
    description: "Description:",
    submit: "Submit",
    reset: "Reset",
    enterName: "Please enter the category name",
    nameLength: "Length should be between 2 and 140 characters",
    confirmSubmit: "Do you want to submit the data?",
    prompt: "Prompt",
    confirm: "Confirm",
    cancel: "Cancel",
    submitSuccess: "Submitted successfully",
    editSuccess: "Edited successfully",
    validationFailed: "Validation failed",
    noParent: "No Parent Category",
    atLeastOne: "At least one must be left",
    maxThree: "Up to three can be added",
    filterAttr: "Filter Attribute:"
  },

  orderIndex: {
    chooseUser: "Choose user:",
    addOrder:"Add order",
    filterSearch: "Filter Search",
    search: "Search",
    reset: "Reset",
    inputSearch: "Input Search:",
    orderSn: "Order Number",
    receiver: "Receiver:",
    receiverNameOrPhone: "Receiver Name/Phone Number",
    submitTime: "Submit Time:",
    selectTime: "Select Time",
    orderStatus: "Order Status:",
    all: "All",
    orderCategory: "Order Category:",
    orderSource: "Order Source:",
    dataList: "Data List",
    id: "ID",
    createTime: "Create Time",
    memberUsername: "User Account",
    totalAmount: "Total Amount",
    payType: "Payment Method",
    sourceType: "Order Source",
    status: "Order Status",
    operations: "Operations",
    viewOrder: "View Order",
    closeOrder: "Close Order",
    allOrder: "All Order",
    deliverOrder: "Deliver Order",
    trackOrder: "Track Order",
    deleteOrder: "Delete Order",
    batchOperate: "Batch Operate",
    confirm: "Confirm",
    operationNote: "Operation Note",
    enterContent: "Enter Content",
    cancel: "Cancel",
    pendingPayment: "Pending Payment",
    pendingShipment: "Pending Shipment",
    shipped: "Shipped",
    completed: "Completed",
    closed: "Closed",
    invalidOrder: "Invalid Order",
    normalOrder: "Normal Order",
    flashOrder: "Flash Order",
    pcOrder: "PC Order",
    appOrder: "APP Order",
    batchShipment: "Batch Shipment",
    alipay: "Online Alipay",
    wechat: "Online WeChat",
    unpaid: "Unpaid",
    bank: "Offline Bank",
    paypal: "Online Paypal",
    blockchain: "Offline Blockchain",
    cash: "Offline Cash",
    others: "Others",
    selectOrder: "Please select the orders to operate",
    noShippableOrder: "No shippable orders in the selected orders",
    emptyNote: "Operation note cannot be empty",
    modifySuccess: "Modified successfully",
    deleteConfirmation: "Are you sure you want to proceed with this deletion?",
    prompt: "Prompt",
    deleteSuccess: "Deleted successfully"
  },
  orderDetail: {
    remark:"Remark",
    exceedAmount:"Exceed order amount",
    chooseProduct:"Choose Product:",
    confirmMarkOrder:"Confirm to mark order?",
    confirmCloseOrder:"Confirm to close order?",
    confirmDeleteOrder:'Confirm to delete order?',
    delivery: "Delivered",
    modifyPayStatus: "Paid",
    submitOrder: "Submit Order",
    payOrder: "Pay Order",
    platformDelivery: "Platform Delivery",
    confirmReceipt: "Confirm Receipt",
    completeEvaluation: "Complete Evaluation",
    currentOrderStatus: "Order Status",
    modifyProductInfo: "Modify Product Info",
    add: "Add product",
    modifyReceiverInfo: "Modify Receiver Info",
    modifyFeeInfo: "Modify Fee Info",
    sendMessage: "Modify Order Status",
    closeOrder: "Close Order",
    markOrder: "Mark Order",
    cancelOrder: "Cancel Order",
    trackOrder: "Track Order",
    deleteOrder: "Delete Order",
    basicInfo: "Basic Information",
    orderNumber: "Order Number",
    deliverySerialNumber: "Delivery Serial Number",
    userAccount: "User Account",
    realName: "Real Name",
    mobile: "Mobile",
    paymentMethod: "Pay Method",
    balanceAmount: "Balance Amount",
    orderSource: "Order Source",
    orderType: "Order Type",
    deliveryMethod: "Delivery Company",
    logisticsNumber: "Logistics Number",
    autoConfirmReceiptTime: "Auto Confirm Receipt Time",
    orderEarnPoints: "Order Earn Points",
    orderEarnGrowth: "Order Earn Growth",
    promotionInfo: "Promotion Info",
    receiverInfo: "Receiver Information",
    receiver: "Receiver",
    phoneNumber: "Phone",
    postalCode: "Postal",
    address: "Address",
    productInfo: "Product Information",
    productImage: "Product Image",
    productName: "Name",
    brand: "Brand",
    price: "Price",
    productSn: "Product SN",
    attribute: "Attribute",
    quantity: "Quantity",
    subtotal: "Subtotal",
    total: "Total",
    feeInfo: "Fee Information",
    productTotal: "Product",
    freight: "Freight",
    coupon: "Discount",
    confirmReceiverUpdate:"Are you sure to confirm to update receiver?",
    confirmFeeUpdate:"Are you sure to confirm to update fee?",
    pointsDeduction: "Points Deduction",
    promotionDiscount: "Discount",
    discountAmount: "Discount",
    orderTotalAmount: "Order Total Amount",
    payableAmount: "Payable",
    operationInfo: "Operation Information",
    operator: "Operator",
    operationTime: "Operation Time",
    orderStatus: "Order Status",
    paymentStatus: "Payment Status",
    deliveryStatus: "Delivery Status",
    note: "Note",
    confirm: "Confirm",
    cancel: "Cancel",
    updateReceiverInfo: "Update Receiver Info",
    updateFeeInfo: "Update Fee Info",
    sendStationMessage: "Send Station Message",
    operationNote: "Operation Note",
    addressDetail: "Detailed Address",
    selectRegion: "Select Region",
    selectProduct: "Select Product",
    successfulUpdate: "Update successful!",
    successfulSend: "Message sent successfully!",
    successfulClose: "Order closed successfully!",
    successfulMark: "Order marked successfully!",
    successfulDelete: "Order deleted successfully!",
    warning: "Warning",
    prompt: "Prompt",
    pendingDelivery:'Pending Delivery',
    delivered:'Delivered',
    completed:'Completed',
    closed:'Closed',
    invalidOrder:'Invalid Order',
    pendingPayment:'Pending Payment',
    unpaid:'UnPaid',
    refunded:'Refunded',
    paid:'Paid',
    notShipped:"Not Shipped",
    shipped:"Shipped",
    empty:"Empty",
    appOrder:"App",
    pcOrder:"Pc",
    alipay:"Online Alipay",
    wechat:"Online Wechat",
    blockchain: "Offline Blockchain",
    bank: "Offline Bank Transfer",
    paypal: "Online Paypal",
    cash: "Offline Cash",
    others: "Offline Others",
    onlinePaypal: "Online Paypal",
    normalOrder:"Normal Order",
    seckillOrder:"Second Kill",
    receiverName:"Receiver Name",
    country:"Country",
    city:"City",
  },
  logisticsDialog: {
    orderTracking: "Order Tracking",
    orderSubmitted: "Order has been submitted, waiting for payment",
    paymentSuccessful: "Order payment successful",
    scanInBeijing: "Scanning at Beijing, waiting for payment",
    scanInShenzhen: "Unloading at Guangdong Shenzhen Hub, waiting for payment",
    dispatchInShenzhen: "Dispatching from Guangdong Shenzhen",
    arrivalInShenzhen: "Arrived at Guangdong Shenzhen Hub, will be delivered soon",
    orderReceived: "Order received, looking forward to serving you again"
  },
  "deliverOrderList": {
    "shippingList": "Shipping List",
    "orderNumber": "Order Number",
    "receiver": "Receiver",
    "phoneNumber": "Phone Number",
    "postalCode": "Postal Code",
    "address": "Address",
    "deliveryMethod": "Delivery Company",
    "selectLogisticsCompany": "Please select a logistics company",
    "trackingNumber": "Tracking Number",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "confirmShipping": "Do you want to proceed with the shipment?",
    "tip": "Tip",
    "shippingSuccess": "Shipment successful!",
    "shippingCancelled": "Shipment cancelled"
  },
  "orderReturnApply": {
    "filterSearch": "Filter Search",
    "search": "Search",
    "reset": "Reset",
    "searchInput": "Search Input:",
    "status": "Status:",
    "applyTime": "Apply Time:",
    "operator": "Operator:",
    "handleTime": "Handle Time:",
    "dataList": "Data List",
    "serviceOrderNo": "Service Order No",
    "userAccount": "User Account",
    "refundAmount": "Refund Amount",
    "applyStatus": "Apply Status",
    "operation": "Operation",
    "viewDetail": "View Detail",
    "batchOperation": "Batch Operation",
    "confirm": "Confirm",
    "selectTime": "Please select time",
    "all": "All",
    "selectOperation": "Please select the application to operate",
    "confirmDelete": "Do you want to proceed with the deletion?",
    "tip": "Tip",
    "deleteSuccess": "Delete successful!",
    "pending": "Pending",
    "returning": "Returning",
    "completed": "Completed",
    "rejected": "Rejected",
    "batchDelete": "Batch Delete"
  },
  "orderReason": {
    "dataList": "Data List",
    "add": "Add",
    "id": "ID",
    "reasonType": "Reason Type",
    "sort": "Sort",
    "status": "Status",
    "addTime": "Add Time",
    "operation": "Operation",
    "edit": "Edit",
    "delete": "Delete",
    "batchOperation": "Batch Operation",
    "confirm": "Confirm",
    "addReason": "Add Return Reason",
    "enable": "Enable",
    "cancel": "Cancel",
    "addSuccess": "Add successful!",
    "updateSuccess": "Update successful!",
    "statusUpdateSuccess": "Status update successful",
    "selectItems": "Please select items to operate",
    "confirmDelete": "Do you want to proceed with the deletion?",
    "tip": "Tip",
    "deleteSuccess": "Delete successful!"
  },
  "orderApplyDetail": {
    "returnGoods": "Return Goods",
    "productImage": "Product Image",
    "productName": "Product Name",
    "brand": "Brand",
    "priceSku": "Price/SKU",
    "price": "Price",
    "sku": "SKU",
    "attribute": "Attribute",
    "quantity": "Quantity",
    "subtotal": "Subtotal",
    "total": "Total",
    "serviceOrderInfo": "Service Order Info",
    "serviceOrderNo": "Service Order No",
    "applyStatus": "Apply Status",
    "orderNo": "Order No",
    "view": "View",
    "applyTime": "Apply Time",
    "userAccount": "User Account",
    "contactName": "Contact Name",
    "contactPhone": "Contact Phone",
    "returnReason": "Return Reason",
    "problemDescription": "Problem Description",
    "proofImages": "Proof Images",
    "orderAmount": "Order Amount",
    "confirmRefundAmount": "Confirm Refund Amount",
    "selectReceivingPoint": "Select Receiving Point",
    "receiverName": "Receiver Name",
    "region": "Region",
    "detailAddress": "Detail Address",
    "phone": "Phone",
    "handler": "Handler",
    "handleTime": "Handle Time",
    "handleNote": "Handle Note",
    "receiver": "Receiver",
    "receiveTime": "Receive Time",
    "receiveNote": "Receive Note",
    "confirmReturn": "Confirm Return",
    "rejectReturn": "Reject Return",
    "confirmReceive": "Confirm Receive",
    "confirmOperation": "Do you want to proceed with this operation?",
    "tip": "Tip",
    "operationSuccess": "Operation successful!",
    "pending": "Pending",
    "returning": "Returning",
    "completed": "Completed",
    "rejected": "Rejected"
  },
  "hot": {
    "filterSearch": "Filter Search",
    "search": "Search",
    "reset": "Reset",
    "productName": "Product Name",
    "recommendStatus": "Recommend Status",
    "all": "All",
    "dataList": "Data List",
    "selectProduct": "Select Product",
    "id": "ID",
    "isRecommended": "Is Recommended",
    "sort": "Sort",
    "status": "Status",
    "operation": "Operation",
    "setSort": "Set Sort",
    "delete": "Delete",
    "batchOperation": "Batch Operation",
    "confirm": "Confirm",
    "productNameSearch": "Product Name Search",
    "productSn": "Product Number",
    "price": "Price",
    "cancel": "Cancel",
    "setRecommended": "Set as Recommended",
    "cancelRecommended": "Cancel Recommendation",
    "notRecommended": "Not Recommended",
    "recommended": "Recommended",
    "selectRecord": "Please select a record",
    "selectOperationType": "Please select a batch operation type",
    "confirmAdd": "Do you want to add this?",
    "tip": "Tip",
    "addSuccess": "Added Successfully!",
    "confirmUpdateSort": "Do you want to change the sort order?",
    "updateSortSuccess": "Sort order updated successfully!",
    "confirmUpdateRecommendStatus": "Do you want to change the recommendation status?",
    "updateSuccess": "Updated Successfully!",
    "cancelOperation": "Operation cancelled!",
    "confirmDelete": "Do you want to delete this recommendation?",
    "deleteSuccess": "Deleted Successfully!"
  },

  "new": {
    "filterSearch": "Filter Search",
    "search": "Search",
    "reset": "Reset",
    "productName": "Product Name",
    "recommendStatus": "Recommend Status",
    "all": "All",
    "dataList": "Data List",
    "selectProduct": "Select Product",
    "id": "ID",
    "isRecommended": "Is Recommended",
    "sort": "Sort",
    "status": "Status",
    "operation": "Operation",
    "setSort": "Set Sort",
    "delete": "Delete",
    "batchOperation": "Batch Operation",
    "confirm": "Confirm",
    "productNameSearch": "Product Name Search",
    "productSn": "Product SN",
    "price": "Price",
    "cancel": "Cancel",
    "setRecommended": "Set Recommended",
    "cancelRecommended": "Cancel Recommended",
    "notRecommended": "Not Recommended",
    "recommended": "Recommended",
    "selectRecord": "Please select a record",
    "selectOperationType": "Please select a batch operation type",
    "confirmAdd": "Do you want to add?",
    "tip": "Tip",
    "addSuccess": "Add successful!",
    "confirmUpdateSort": "Do you want to update the sort?",
    "updateSortSuccess": "Sort update successful!",
    "confirmUpdateRecommendStatus": "Do you want to update the recommend status?",
    "updateSuccess": "Update successful!",
    "cancelOperation": "Operation cancelled!",
    "confirmDelete": "Do you want to delete the recommendation?",
    "deleteSuccess": "Delete successful!"
  },
  "advertiseIndex": {
    "cancel":"Cancel",
    "filterSearch": "Filter Search",
    "search": "Search",
    "reset": "Reset",
    "adName": "Ad Name",
    "adPosition": "Ad Position",
    "expireTime": "Expire Time",
    "selectTime": "Please Select Time",
    "dataList": "Data List",
    "addAd": "Add Ad",
    "id": "ID",
    "adImage": "Ad Image",
    "time": "Time",
    "startTime": "Start Time",
    "status": "Online/Offline",
    "clickCount": "Click Count",
    "orderCount": "Order Count",
    "operation": "Operation",
    "edit": "Edit",
    "delete": "Delete",
    "batchOperation": "Batch Operation",
    "confirm": "Confirm",
    "pcCarousel": "PC Homepage Carousel",
    "appCarousel": "APP Homepage Carousel",
    "confirmUpdateStatus": "Do you want to change the online/offline status?",
    "tip": "Tip",
    "updateSuccess": "Update successful!",
    "cancelOperation": "Operation cancelled!",
    "selectRecord": "Please select a record",
    "selectOperationType": "Please select a batch operation type",
    "confirmDelete": "Do you want to delete this ad?",
    "deleteSuccess": "Delete successful!"
  },
  "homeAdvertiseDetail": {
    "selectDate":"Select Date",
    "adName": "Ad Name",
    "adPosition": "Ad Position",
    "startTime": "Start Time",
    "expireTime": "Expire Time",
    "status": "Online/Offline",
    "adImage": "Ad Image",
    "sort": "Sort",
    "adUrl": "Jump To",
    "adNote": "Ad Note",
    "enterContent": "Please enter content",
    "submit": "Submit",
    "reset": "Reset",
    "pcCarousel": "PC Homepage Carousel",
    "appCarousel": "APP Homepage Carousel",
    "offline": "Offline",
    "online": "Online",
    "enterAdName": "Please enter the ad name",
    "nameLength": "Length between 2 and 140 characters",
    "enterAdUrl": "Please enter the ad URL",
    "selectStartTime": "Please select start time",
    "selectExpireTime": "Please select expire time",
    "selectAdImage": "Please select ad image",
    "confirmSubmit": "Do you want to submit the data?",
    "tip": "Tip",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "updateSuccess": "Update successful",
    "submitSuccess": "Submit successful",
    "validationFailed": "Validation failed"
  },
  "member": {
    mergeInfo: "The order information of the source user will be transferred to the target user. Basic information of the target user will be retained, but if any basic information is missing, it will be supplemented by the source user's information.",
    srcUser: "Source User",
    destUser: "Target User",
    "filterSearch": "Filter Search",
    "queryResult": "Search",
    "inputSearch": "Input Search",
    "username": "Username",
    "id": "ID",
    "optional":"Optional",
    "nickname": "Nickname",
    "name": "Real name",
    "mobile": "Mobile",
    "companyName": "Company name",
    "country": "Country",
    "taxId": "Id number",
    "phone": "Phone",
    "icon": "Icon",
    "level": "Level",
    "applyStatus": "Apply Status",
    "operation": "Operation",
    "edit": "Edit",
    "add": "Add",
    "merge": "Merge",
    "enterEmail": "Enter email address",
    "memberStatus": "Member Status",
    "pleaseSelect": "Please Select",
    "memberLevel": "Member Level",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "showBrand": "Show Brand",
    "hideBrand": "Hide Brand",
    "success": "Success",
    "reject": "Reject",
    "confirmDelete": "Do you want to delete this record?",
    "tip": "Tip",
    "deleteSuccess": "Delete successful"
  },
  "navbar": {
    "home": "Home",
    "logout": "Logout"
  },
  menu: {
    balanceList:'Balance List',
    distributeList:'Pay Record',
    link: 'Link',
    relationList:'Refer',
    click: 'Click',
    rms: 'Refer',
    pay: 'Pay',
    Shop:'Shop',
    products: 'Products',
    productList: 'Product List',
    addProduct: 'Add Product',
    productCategories: 'Product Categories',
    productAttrs: 'Product Attrs',
    brandManagement: 'Brand Management',
    orders: 'Orders',
    orderList: 'Order List',
    orderSettings: 'Order Settings',
    returnApplicationHandling: 'Return Application Handling',
    returnReasonSettings: 'Return Reason Settings',
    marketing: 'Marketing',
    flashSaleActivityList: 'Flash Sale Activity List',
    couponList: 'Coupon List',
    brandRecommendations: 'Brand Recommendations',
    newProductRecommendations: 'New Product',
    popularRecommendations: 'Recommend Product',
    specialRecommendations: 'Special Recommendations',
    bannerList: 'Banner List',
    permissions: 'Permissions',
    userList: 'User',
    roleList: 'Role List',
    menuList: 'Menu List',
    resourceList: 'Resource List',
    stores: 'Stores',
    storeList: 'Store List',
    addStore: 'Add Store',
    users: 'Users',
  },
  editorImage:{
    wait:'Please wait until all images are successfully uploaded or network problems occur. Please refresh the page and upload again.'
  },
  pay:{
    select:"Select item:",
    remark:"Remark:",
    thankyou:"At present, the system is still in the trial period, no payment can be used. After the trial period is over, the expiration time will be calculated. Thank you very much for paying to support the development of the system\n" +
      "\n",
    introduce:"Introduce:",
    permission:"After payment you will have the right to open a shop",
    title:"MyTrustStores Seller VIP Member",
    oneMonthLabel:"One month - $20.00 USD（original price $100 USD)",
    threeMonthLabel:"Three months - $60.00 USD（original price $300 USD)",
    sixMonthLabel:"Six months - $120.00 USD（original price $600 USD)",
    oneYearLabel:"One Year - $240.00 USD（original price $1200 USD)",
    threeYearLabel:"Three Years - $720.00 USD（original price $3600 USD)",
    sixYearLabel:"Six Years - $1440.00 USD（original price $7200 USD)",
  },
  relation:{
    ip:'IP',
    agent:'Device Info',
    code:'Invite Code',
    dialogRatio:'Ratio',
    clickTime:'Click Time',
    dialogTitle:"Set Default Ratio",
    setDefaultRatio:'Set Default Ratio',
    username:'Username',
    referTime:'Refer Time',
    status:'Status',
    level:'Level',
    ratio:'Distribute Ratio',
    confirmAdjustRatio:'Confirm to adjust distribute ratio?',
    adjustRatio:'Adjust ratio',
  },
  link:{
    inviteCode:'Referral code',
    kind:'Kind',
    createTime:'Create Time',
    createLink:"Create Referral Link",
    all:"All",
    onlyReferee:"Only Referee",
    onlyMerchant:"Only Merchant",
    copyInviteUrl:"Share",
    success:"Copy successfully",
  },
  distribute:{
    reward:'Reward',
    username:'Username',
    payUsername:"Payer Username",
    payAmount:"Pay Amount",
    reason:"Reward Reason",
    createTime:"Create Time",

  }
}



// WEBPACK FOOTER //
// ./src/locale/en.js